import environments from "../environment";

/**
 * Origin of the customer-facing landing app.
 * Resolved at runtime from the environment (PUBLIC_SITE_ORIGIN env var),
 * with "https://whalelo.net" as the production fallback.
 * Set PUBLIC_SITE_ORIGIN in your .env for local dev or staging landing URLs.
 */
export function getPublicSiteOrigin(): string {
	return (environments.publicSiteOrigin || "https://whalelo.net").replace(/\/$/, "");
}

export function buildStationCheckoutUrl(partnerId: string | number): string {
	return `${getPublicSiteOrigin()}/order?locationId=${partnerId}`;
}
